import type { EventName, EventPayloads } from "#types/events.ts";

/**
 * Dispatches a custom event with optional payload
 *
 * @param eventName - The name of the event to dispatch
 * @param payload - Optional payload data for the event
 */
export function dispatchCustomEvent<T extends EventName>(
    eventName: T,
    payload?: EventPayloads[T]
): void {
    const customEvent = payload
        ? new CustomEvent(eventName, { detail: payload })
        : new CustomEvent(eventName);

    window.dispatchEvent(customEvent);
}
